import React from 'react';
import DashboardLayout from './DashboardLayout';

const ComingSoon = () => {
    return (
        <DashboardLayout>
            <div className="main-content text-center" >
                <h3> Apply to multiple jobs?   </h3>
                <h4>Our AI and Humans will help you..</h4>

            </div>
        </DashboardLayout>
    )
}

export default ComingSoon;